import { createProviderToken } from '@core/common-legacy';
import type { RecentItemTransformer } from '@core/dashboard-types';

export const { provide: provideRecentItem, inject: injectRecentItems } =
  createProviderToken<RecentItemTransformer>('recentItem')(true);
